module.exports = __webpack_public_path__ + "media/images/traq_logo-d142b7647bead7216bc529b89c63b377.svg";